import React from 'react'

import { twm } from '../../lib/utils/twm'

export interface CallOutProps {
  icon: React.ReactNode
  children: React.ReactNode
  classes?: {
    root?: string
    message?: string
  }
}

export const CallOut: React.FC<CallOutProps> = ({
  children,
  icon,
  classes,
}) => {
  return (
    <div
      className={twm(
        'flex flex-row items-center justify-center gap-2 rounded-md bg-blue-light-fade px-8 py-2 max-w-[500px]',
        classes?.root,
      )}
    >
      <div className="h-6 w-6">{icon}</div>
      <span
        className={twm('font-heading text-md text-indigo-50', classes?.message)}
      >
        {children}
      </span>
    </div>
  )
}

export default CallOut
